import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Dropdown = (props: SvgProps) => (
  <Svg viewBox='0 0 13 5' fill='none' {...props}>
    <Path d='M6.5 5L12.1292 0.5H0.870835L6.5 5Z' fill='currentColor' />
  </Svg>
)
